import { Cartesian3 } from "cesium";
import { Color } from "cesium";

/** Edit these values to change the ClippingBox appearance, or display debugging options. */
export const CesiumViewerClippingBoxConfig = {
  faces: {
    color: Color.WHITE.withAlpha(0.2),
    outlineColor: Color.WHITE,
    selectedColor: Color.BLUE.withAlpha(0.3),
    hoveredColor: Color.BLUE.withAlpha(0.1),
    normals: [
      /**
       * The normals for each box face. Could be extended in the future to
       * support other shapes, but would likely involve changes to the way
       * the face positions and dimensions are currently being calculated.
       */
      new Cartesian3(-1, 0, 0),
      new Cartesian3(1, 0, 0),
      new Cartesian3(0, -1, 0),
      new Cartesian3(0, 1, 0),
      new Cartesian3(0, 0, -1),
      new Cartesian3(0, 0, 1),
    ],
  },
  clippedEdges: {
    color: Color.TURQUOISE,
    width: 5.0,
  },
  debug: {
    /**
     * Setting `enabled` to true turns debugging on, which can be
     * further fine tuned with each item's `show` property below.
     */
    enabled: false,
    boxOrigin: {
      /**
       * Shows a point at the Cartesian3 defining `boxOrigin`,
       * which is the point at which the ClippingBox is initialized,
       * and at which all other calculations are based upon until
       * the ClippingBox is disposed of.
       */
      show: true,
      pixelSize: 25,
      color: Color.FIREBRICK,
    },
    boxCenter: {
      /**
       * Shows a point at the Cartesian3 defining `boxCenter`,
       * which is the centroid of all `faceCenters` and
       * the point at which the box should rotate around.
       */
      show: true,
      pixelSize: 25,
      color: Color.ORANGE,
    },
    faceCenter: {
      /**
       * Displays a dot at the center of each box face.
       * Useful when debugging `boxCenter`, which is calculated
       * as the centroid of all `faceCenters`.
       */
      show: true,
      pixelSize: 18,
      color: Color.SLATEBLUE,
    },
    faceAxis: {
      /**
       * Displays an axis on a clicked face oriented opposite the face normal.
       * Useful when debugging click and drag behavior when moving a box face.
       */
      show: false,
      length: 100,
    },
    clickTarget: {
      /**
       * Displays a dot on a box face at the point where it was clicked.
       * Useful for debugging click and drag behavior when combined with the `faceAxis` debug.
       */
      show: true,
      size: 6,
      color: Color.LIGHTGREEN,
    },
    boundingVolume: {
      /**
       * Displays a bounding octree for each loaded tileset.
       * Useful when debugging a tileset's bounding volume.
       */
      show: false,
    },
  },
};
